import { BaseApi } from "../utils/request";

// InviteFriends 模块类型定义
export interface InviteFriendsCommissionData {
  totalAmount: number;
  levelData: Array<{
    level?: number;
    validBets?: number;
    bettingRebate?: number;
  }>;
}

export interface InviteFriendsIncomeSummaryResponse {
  todayIncome: InviteFriendsCommissionData;
  totalIncome: InviteFriendsCommissionData;
}

export interface InviteFriendsCommissionRecordsRequest {
  pageSize?: number;
  pageIndex?: number;
  userName?: string;
  type?: string;
  dateRange?: {
    start: number;
    finish: number;
  };
}

export interface InviteFriendsCommissionRecord {
  [key: string]: any;
}

export interface InviteFriendsCommissionRecordsResponse {
  page: {
    content: InviteFriendsCommissionRecord[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
  };
  totalAmount: number;
}

// 邀请任务相关类型定义
export interface RewardItem {
  icon?: string;
  name: string;
  rewardAmount: number;
  currentCount: number;
  targetCount: number;
  satisfied: boolean;
  paid: boolean;
  relationId: string;
}

export interface InviteTaskConfigResponse {
  data?: RewardItem[];
  model?: RewardItem[];
}

export interface DrawRewardRequest {
  id: string;
  type: string;
}

export interface InvitedListRequest {
  pageSize?: number;
  pageIndex?: number;
  qualificationFilter?: string;
  dateRange?: {
    start: number;
    finish: number;
  };
}

export interface InvitedUser {
  userId: string;
  username: string;
  registrationDate: number;
  registrationDateStr: string;
  firstDepositDate?: number;
  firstDepositDateStr?: string;
  qualified: boolean;
  level: number;
}

export interface InvitedListResponse {
  page: {
    content: InvitedUser[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
  };
}

export class InviteFriendsApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * 获取所有收入汇总数据
   * @returns Promise<InviteFriendsIncomeSummaryResponse>
   */
  async incomeSummaryAllNew(): Promise<InviteFriendsIncomeSummaryResponse> {
    const response = await this.get<InviteFriendsIncomeSummaryResponse, true>(
      "/api/user_invite_new/income_summary_all_new"
    );
    return response.data.model;
  }

  /**
   * 获取所有佣金记录
   * @param params 查询参数
   * @returns Promise<InviteFriendsCommissionRecordsResponse>
   */
  async commissionRecordsAllNew(
    params: InviteFriendsCommissionRecordsRequest
  ): Promise<InviteFriendsCommissionRecordsResponse> {
    const response = await this.post<
      InviteFriendsCommissionRecordsResponse,
      true
    >("/api/user_invite_new/commission_records_all_new", params);
    return response.data.model;
  }

  /**
   * 获取邀请任务配置列表
   * @returns Promise<RewardItem[]>
   */
  async inviteTaskConfigNew(): Promise<RewardItem[]> {
    const response = await this.get<RewardItem[], true>(
      "/api/user_invite_new/invite_task_config_new",
      undefined,
      { ignore: true }
    );
    return response.data.model;
  }

  /**
   * 领取邀请奖励
   * @param params 领取参数
   * @returns Promise<any>
   */
  async drawReward(params: DrawRewardRequest): Promise<any> {
    const response = await this.post<any, false>(
      "/api/bonus_task/draw_new",
      params
    );
    return response;
  }

  /**
   * 获取受邀用户列表
   * @param params 查询参数
   * @returns Promise<InvitedListResponse>
   */
  async invitedListNew(
    params: InvitedListRequest
  ): Promise<InvitedListResponse> {
    const response = await this.post<InvitedListResponse, true>(
      "/api/user_invite_new/invited_list_all_new",
      params,
      { ignore: true }
    );
    return response.data.model || response.data;
  }
}

export const inviteFriendsApi = new InviteFriendsApi();
